import { Card, Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { RingComplianceStatus } from 'business/quality-control/pages/ring-compliance-report/hooks/data/types';
import { formatDateWithMiddleDot } from 'technical/format/date';

import { RingComplianceStatusTag } from './ring-compliance-status-tag';

type FrameStatus =
  | RingComplianceStatus.Compliant
  | RingComplianceStatus.Approved
  | RingComplianceStatus.Refused;

interface Props {
  status: FrameStatus;
  date: string;
  authorName: string | null;
  description?: string;
  refusedSegments?: { segmentType: string }[] | null;
}

export const StatusFrame = ({
  status,
  date,
  authorName,
  description,
  refusedSegments,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card size="small" style={{ width: 300 }}>
      <Flex vertical gap={4}>
        <Flex align="center" justify="space-between">
          <Typography.Text strong>
            {t('qualityControl.ringComplianceReport.detail.frame.title', {
              context: status,
            })}
          </Typography.Text>
          <RingComplianceStatusTag status={status} />
        </Flex>
        <Typography.Text>
          {formatDateWithMiddleDot(date)}
          {authorName && ` • ${authorName}`}
        </Typography.Text>
        {description && (
          <Typography.Text italic style={{ marginTop: 8 }}>
            {description}
          </Typography.Text>
        )}
        {refusedSegments && refusedSegments.length > 0 && (
          <Typography.Text style={{ marginTop: 8 }}>
            {t(
              'qualityControl.ringComplianceReport.detail.frame.refusedSegments',
            )}
            {' : '}
            {refusedSegments.map((segment) => segment.segmentType).join(', ')}
          </Typography.Text>
        )}
      </Flex>
    </Card>
  );
};
